export default "__VITE_ASSET__cb60bc78__"